module.exports = __webpack_public_path__ + "img/table-delc-icon.4470a642.svg";